import { render, staticRenderFns } from "./WorkGroups.vue?vue&type=template&id=b09bbbae&scoped=true&"
import script from "./WorkGroups.vue?vue&type=script&lang=js&"
export * from "./WorkGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09bbbae",
  null
  
)

export default component.exports